import { api } from '../../lib/api.ts';

export interface DashboardRecentRequest {
  id: string;
  refNumber: number;
  title: string;
  status: 'DRAFT' | 'SENT' | 'CLOSED';
}

export interface DashboardData {
  gsrsOpen: number;
  activeRfqs: number;
  readyToAward: number;
  awaitingPaymentCount: number;
  awaitingPaymentTotal: number;
  activeVendors: number;
  recentRequests: DashboardRecentRequest[];
}

export const dashboardApi = {
  get: () => api.get<DashboardData>('/dashboard').then((r) => r.data),
};
